(function() {
  function calculateMinHeight() {
    const titleElement = document.querySelector('.article-template__title');
    const excerptElement = document.querySelector('.art-Header_Content');
    const containerElement = document.querySelector('.article-template > *:first-child:not(.article-template__hero-container)');
    const heroElement = document.querySelector('.article-template__hero-adapt.media');
    
    if (!titleElement || !containerElement || !heroElement) return;
    
    const isMobile = window.innerWidth <= 900;
    
    // Detect number of lines in the title using getClientRects()
    const range = document.createRange();
    range.selectNodeContents(titleElement);
    const rects = range.getClientRects();
    const lineCount = rects.length;
    
    // Alternative method: calculate from height and line-height (fallback)
    const lineHeight = parseFloat(window.getComputedStyle(titleElement).lineHeight);
    const titleHeight = excerptElement.offsetHeight;
    const calculatedLineCount = Math.round(titleHeight / lineHeight);
    
    // Use the more accurate method (getClientRects) or fallback to calculated
    const actualLineCount = lineCount > 0 ? lineCount : calculatedLineCount;
    
    if (isMobile) {
      // For mobile: calculate height based on title, excerpt, and image
      const tagListElement = document.querySelector('.art-TagList');
      const metaElement = document.querySelector('.article-template__meta');
      const heroContainer = document.querySelector('.article-template__hero-container');
      
      // Get heights of all components
      const tagListHeight = tagListElement ? tagListElement.offsetHeight : 0;
      const contentHeight = excerptElement ? excerptElement.offsetHeight : 0;
      const metaHeight = metaElement ? metaElement.offsetHeight : 0;
      const imageHeight = heroContainer ? heroContainer.offsetHeight : 0;
      
      // Calculate total: tags + content + image + padding (40px top for tags + 24px bottom padding)
      // Image overlaps 20% into white area, so we subtract that overlap
      const imageOverlap = imageHeight * 0.2;
      const totalHeight = tagListHeight + contentHeight + metaHeight + imageHeight - imageOverlap - 10;
      
      containerElement.style.minHeight = totalHeight + 'px';
      containerElement.style.height = totalHeight + 'px';
    } else {
      // For desktop: hero height + title height
      const heroHeight = heroElement.offsetHeight;
      const minHeight = heroHeight + titleHeight - 60;
      containerElement.style.minHeight = minHeight + 'px';
      containerElement.style.height = '';
    }
    
    // Optional: log line count for debugging
    // console.log('Is Mobile:', isMobile, 'Title line count:', actualLineCount, 'Title height:', titleHeight, 'Min-height:', containerElement.style.minHeight);
  }
  
  // Run on page load (wait for fonts and images to load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(calculateMinHeight, 200);
      window.addEventListener('load', function() {
        setTimeout(calculateMinHeight, 100);
      });
    });
  } else {
    setTimeout(calculateMinHeight, 200);
    if (document.readyState === 'complete') {
      setTimeout(calculateMinHeight, 100);
    } else {
      window.addEventListener('load', function() {
        setTimeout(calculateMinHeight, 100);
      });
    }
  }
  
  // Recalculate on resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(calculateMinHeight, 250);
  });
})();